export const INITIAL_STATE = {
  revenueTypeEnabled: false,
  revTypeSearchStr: '',
  successEventFilter: 'all',
};
